import React from 'react';
import './PLPFiltersItem.scss';

import { connect } from 'react-redux';
import { v4 } from 'uuid';

const PLPFiltersItem = props => {
  const { filter, FilterDataObj, modifySelectedFilterList } = props;
  const filterData = filter?.data;
  const filterOptions = filterData?.[0]?.options;

  const checkedOptions = (FilterDataObj[filter.id] || []).map(({ childid }) => childid);

  const isFilterContainsImages = filterOptions.some(({ image_url }) => !!image_url);

  return (
    <div className="plp-filters-item">
      <h2 className="plp-filters-item__title od-font-bold">{filter?.name}</h2>
      <div
        className={`plp-filters-item__options ${
          filterOptions?.length > 3 && 'plp-filters-item__options--grid'
        }`}
      >
        {filterOptions?.length > 0 &&
          filterOptions?.map(option => {
            const isActive = checkedOptions.includes(option.id);

            return (
              <div
                key={v4()}
                className={`plp-filters-item__option od-font-reg ${
                  isActive &&
                  `plp-filters-item__option--active-${isFilterContainsImages ? 'image' : 'text'}`
                } ${
                  isFilterContainsImages &&
                  option.image_url &&
                  'plp-filters-item__option--has-image'
                }`}
                onClick={() => modifySelectedFilterList(option.title, option.id, filter)}
              >
                {isFilterContainsImages && option.image_url && (
                  <img alt={option.title} src={option.image_url} />
                )}
                {option.title}
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    categoryType: state.category.categoryType,
    FilterDataObj: state.category.FilterDataObj,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PLPFiltersItem);
